var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{class:_vm.tableClass,attrs:{"id":_vm.tableIdActual}})])}
var staticRenderFns = []

export { render, staticRenderFns }